import React, { useMemo } from "react";
import { useData } from "../../context/DataContext";
import { useAuth } from "../../context/AuthContext";
import { userMatchesField, cellText } from "../../utils/helpers";
import TaskTable from "../../components/TaskTable";
import { USER_TABLE } from "../../context/DataContext";

export default function PendingTasks() {
  const { userRecords, adminRecords, loading } = useData();
  const { user } = useAuth();

  // Build lookup: admin task fully done (all users completed)?
  const adminDoneMap = useMemo(() => {
    const m = {};
    for (const ar of adminRecords) {
      const tid = cellText(ar.fields?.["Task ID"]);
      if (!tid || tid === "—") continue;
      const st = cellText(ar.fields?.["Overall Status"]).toLowerCase();
      m[tid] = st.includes("done") || st.includes("✅");
    }
    return m;
  }, [adminRecords]);

  const allMine = useMemo(() =>
    userRecords.filter((r) => r.user_id === user?.userId),
    [userRecords, user]
  );

  const pending = useMemo(() =>
    allMine.filter((r) => {
      const tid = cellText(r.fields?.["Task ID"]);
      // Task is pending until ALL assigned users complete (admin task = Done)
      return !adminDoneMap[tid];
    }),
    [allMine, adminDoneMap]
  );

  if (loading && userRecords.length === 0) return <div className="loading-box"><div className="spinner" /><span>Loading...</span></div>;

  return (
    <div className="fade-in">
      <TaskTable
        title="⏳ Pending Tasks"
        tableId={USER_TABLE}
        canComplete
        records={pending}
        emptyMsg="No pending tasks. Great job! 🎉"
        statusOptionsOverride={["⬜ Not Started", "🟡 In Progress"]}
        sortDueAsc
      />
    </div>
  );
}
